import ClipboardSvg from 'images/srp-clipboard.svg';
import { IconProps } from './types';
import { FC } from 'react';

const Chain: FC<IconProps> = ({ className }) => {
  return <img className={className} src={ClipboardSvg} />;
};

export default Chain;
